"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var trainingStyles = function (props) {
    return {
        margin: '0 1.5px',
        width: 4,
        height: 4,
        background: props.theme.colors.grey.dark,
        borderRadius: '50%',
        '&:first-child': {
            marginLeft: 0,
        },
    };
};
var animate = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["0% { opacity: 0; }\n50% { opacity: 1; }\n100% { opacity: 0; }"], ["0% { opacity: 0; }\n50% { opacity: 1; }\n100% { opacity: 0; }"])));
var animation = function (props) {
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    animation: ", " 2s ease-out infinite;\n    animation-delay: 0.", "s;\n  "], ["\n    animation: ", " 2s ease-out infinite;\n    animation-delay: 0.", "s;\n  "])), animate, props.delay);
};
var TrainingEllipse = styled_components_1["default"]('span')(trainingStyles, animation);
var Training = function () {
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        "Training",
        react_1["default"].createElement(box_1["default"], { padding: 0, style: { transform: 'translate(-2px, 3px)' } },
            react_1["default"].createElement(TrainingEllipse, { delay: 0 }),
            react_1["default"].createElement(TrainingEllipse, { delay: 2 }),
            react_1["default"].createElement(TrainingEllipse, { delay: 4 }))));
};
exports["default"] = Training;
var templateObject_1, templateObject_2;
